import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const OnboardingDetailsUserView: IView = {
  key: 'viewOnboardingDetailsUser',
  title: 'preonboardingTemplateUser.statusUserView.title',
  roles: [IRoles.ADMINISTRATOR, IRoles.HR],
  view: React.lazy(() => import('./status-user')),
  path: '/status-szablonu/',
};

export default OnboardingDetailsUserView;
